/**
 * Created by Ondra on 10.11.2016.
 */
import React from 'react';

const LogoutButton = () => (
    <div className="boxBtn-inner">
      <svg className={`shape shape-sign-out-alt`}>
        <use xlinkHref={`#shape-sign-out-alt`}></use>
      </svg>
    </div>
);

export default LogoutButton;



// WEBPACK FOOTER //
// ./src/browser/components/buttons/LogoutButton.js